import applicationEventHub from "../events/applicationEventHub";
import Vue from "vue";
import {TweenMax} from 'gsap'

Vue.directive('demo-show',{
  bind(el,binding){
    const eventName=binding.value.event;
    const show=binding.value.show;
    applicationEventHub.$on('eventStarted',(e)=>{
      if(e===eventName){
        if(!show){
          el.style.display = 'block';
        }
        TweenMax.to(el, 1, {scale:1.3,parseTransform: true});
      }else{
        TweenMax.to(el, 1, {scale:1,parseTransform: true,onComplete:()=>{
            if(!show){
              el.style.display = 'none';
            }
          }});
      }
    });

    applicationEventHub.$on('eventEnded',(e)=>{
      if(e===eventName){
        TweenMax.to(el, 1, {scale:1,parseTransform: true,onComplete:()=>{
          if(!show){
            el.style.display = 'none';
          }
        }});
      }
    });

    applicationEventHub.$on('endAllEvents',()=>{
      TweenMax.to(el, 1, {scale:1,parseTransform: true,onComplete:()=>{
          if(!show){
            el.style.display = 'none';
          }
        }});
    });
  },
  inserted(el,binding){
    const show=binding.value.show;
    if(show){
      el.style.display = 'block';
    }else{
      el.style.display = 'none';
    }
  },
  update(el,binding){
    const show=binding.value.show;
    if(show){
      el.style.display = 'block';
    }else{
      el.style.display = 'none';
    }
  },
  unbind(){
    applicationEventHub.$off(['eventStarted','eventEnded','endAllEvents']);
  }

});
